import DOMPurify from 'dompurify';

/**
 * Please take into account that the DOMPurify library reverses attributes.
 * Therefore, for comparison needs, it should apply attributes re-ordering.
 * @see https://github.com/cure53/DOMPurify/issues/435
 */
export const sanitizeHtml = (
  html,
  sortAttributes = false,
  additionalAllowedTags = ['iframe'],
  additionalAllowedAttrs = ['style', 'src', 'title', 'frameborder', 'allowfullscreen'],
) => {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    ADD_TAGS: additionalAllowedTags,
    ADD_ATTR: additionalAllowedAttrs,
  });

  if (!sortAttributes) {
    return sanitizedHtml;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHtml, 'text/html');

  const sortAttrs = (element) => {
    const attributes = Array.from(element.attributes);
    attributes.sort((a, b) => a.name.localeCompare(b.name));
    attributes.forEach(attr => {
      element.removeAttribute(attr.name);
      element.setAttribute(attr.name, attr.value);
    });

    Array.from(element.children).forEach(child => sortAttrs(child));
  };

  Array.from(doc.body.children).forEach(child => sortAttrs(child));

  return doc.body.innerHTML;
};

/**
 * #TODO: Consider refactoring this comparison method to a more robust solution
 * that does not rely on string comparison, as it may lead to edge cases.
 */
export const isHtmlEquivalent = (html1, html2) => {
  return sanitizeHtml(html1, true) === sanitizeHtml(html2, true);
};
